import React, { Component } from 'react';
import { toast } from "react-toastify";


const subTitle= "Download Tegal";
const Title = "Find Your Soulmate";
const desc = "By finding us, you are finally ready to fall in love and start a sacred life in matrimony."
    + " Thousands are already experiencing the benefits Tegal offers!";

let AppListContent= [
    {
        imgUrl: 'assets/images/app/apple.png',
        imgAlt: 'App Thumb',
        title: 'App Store',
        desc: 'Comming soon',
        url:'#'
    },
    {
        imgUrl: 'assets/images/app/playstore.png',
        imgAlt: 'App Thumb',
        title: 'Google Play',
        desc: 'Available on',
        url: 'https://play.google.com/store/apps/details?id=com.syrol.tegal&hl=en'
    },
]

class AppsSection extends Component {
    state = {  } 
    render() { 
        return (
            <section className="app-section bg-theme">
                <div className="container">
                    <div className="section-wrapper padding-tb">
                        <div className="app-content">
                            <h4>{subTitle}</h4>
                            <h2>{Title} </h2>
                            <p>{desc}</p>
                            <ul className="app-download d-flex flex-wrap">
                                {AppListContent.map((val, i) => (
                                    <li key={i}>
                                        <a href={val.url} onClick={()=>{
                                            if(val.url=='#'){
                                                toast.warn('Apple app is comming soon...');
                                            }
                                        }} className="d-flex flex-wrap align-items-center">
                                            <div className="app-thumb">
                                                <img 
                                                    src={`${val.imgUrl}`} 
                                                    alt={`${val.imgAlt}`} 
                                                />
                                            </div>
                                            <div className="app-content">
                                                <p>{val.desc}</p>
                                                <h4>{val.title}</h4>
                                            </div>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="mobile-app">
                            <img src="assets/images/app/mobile-view.png" alt="mbl-view" />
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default AppsSection;